export const AITransparency = () => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="ai-transparency-page">
      <h1 className="mb-2 font-heading text-4xl font-bold text-white">AI Transparency Disclosure</h1>
      <p className="mb-10 text-sm text-slate-500">Last updated: September 2026</p>

      <div className="space-y-8 text-slate-300">
        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">1. All Reports Are AI-Generated Intelligence</h2>
          <p>
            Every Visibility Score, Sentiment reading, Mention Quality assessment, Hallucination Warning, Truth
            Statement, Competitor Deep-Dive, Metadata Audit, and Reputation Scorecard produced by BrandSignal is
            generated by large language models (currently OpenAI, Anthropic Claude, Google Gemini, and Perplexity)
            and BrandSignal's own AI analysis layer. These outputs are <strong>probabilistic estimates of how AI
            models currently describe a brand</strong> - they are not independently verified facts, professional
            opinions, legal findings, or guarantees of real-world brand reputation.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">2. Hallucinations Can Occur In Both Directions</h2>
          <p>
            BrandSignal's Hallucination Warnings and Truth Statements are themselves produced by an AI sub-agent.
            While designed to flag inaccuracies with high precision, this sub-agent can itself misjudge a claim as
            true, false, or unverifiable. Always independently verify any Hallucination Warning or Truth Statement
            before publishing it, relying on it for a business decision, or citing it externally.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">3. No Guarantee of Accuracy or Completeness</h2>
          <p>
            AI model outputs change over time as providers update their systems, and the same prompt can return
            different answers on different days. A Visibility Score is a snapshot at the time of the audit, not a
            permanent or continuously accurate measurement. BrandSignal makes no representation that any report is
            complete, current, or free of error.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">4. Not Legal, Financial, or Professional Advice</h2>
          <p>
            Nothing in a BrandSignal report constitutes legal, financial, medical, or other professional advice.
            Fix Manuals and GEO recommendations are general guidance only. Consult a qualified professional before
            acting on any reputational, legal, or financial matter.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">5. Third-Party AI Providers</h2>
          <p>
            To produce a report, BrandSignal sends brand-related prompts to OpenAI, Anthropic, Google, and
            Perplexity. Each provider processes these prompts under its own terms and privacy practices, which
            BrandSignal does not control. BrandSignal is not affiliated with, and does not claim endorsement from,
            any of these providers.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">6. Limitation of Liability</h2>
          <p>
            BrandSignal, its founders, and its officers (including the BrandSignal Buddy assistant) are not liable
            for any decision made, action taken, or loss incurred in reliance on an AI-generated report, chat
            response, or Truth Statement. Reports are provided "as is" and "as available" without warranties of any
            kind, express or implied. See our <a href="/terms" className="text-openai-cyan hover:underline">Terms of
            Service</a> for the full limitation of liability.
          </p>
        </section>
      </div>
    </div>
  );
};
